import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getSiteEmployeeProductUpdatesAPI(siteEmployeeId: string) {
  return serviceRequest(() => Service.productUpdateControllerGet(siteEmployeeId));
}
